import React from 'react';
import styles from './TipBoxBottom.module.scss';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../../utils/translations/translator';

/* Components */
import { TipValueWithLabel } from '../../TipValueWithLabel/TipValueWithLabel';

export type ConfidenceType = 'MEDIUM' | 'HIGH' | 'MAXIMUM' | 'SUPER';

interface ConfidenceProps {
  confidence: ConfidenceType;
  stake: number;
}

export const Confidence: React.FC<ConfidenceProps> = ({
  confidence,
  stake,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.confidenceContainer}>
      <span className={styles.confidenceMeterWrapper}>
        <div className={styles.bg} id={styles[`${confidence}-bg`]}>
          <div className={styles.lvl} id={styles[confidence]}></div>
        </div>
      </span>
      <TipValueWithLabel label={tr(t, 'confidence')}>
        {tr(t, confidence)}
      </TipValueWithLabel>
      <label className={styles.stake}>
        {tr(t, 'stake')} {stake}
      </label>
    </div>
  );
};
